<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{ CatalogueName }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <div class="main-icon-b" style="margin-right: 20px;">
              <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
              <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="c">全部</el-dropdown-item>
                  <el-dropdown-item command="a">正常</el-dropdown-item>
                  <el-dropdown-item command="b">禁用</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleDbShowData">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)"
                             header-align="center">
              <template #default="{ row }">
                <!-- 特殊处理状态列（假设prop为'status'） -->
                <template v-if="col.prop === 'status'">
                  <el-tag :type="row.status === 1 ? 'success' : 'danger'"
                          size="small"
                          effect="light"
                          :class="'status-tag status-tag-' + row.status">
                    <i :class="row.status === 1 ? 'el-icon-success' : 'el-icon-error'"></i>
                    {{ row.status === 1 ? '正常' : '禁用' }}
                  </el-tag>
                </template>
                <!-- 其他列保持原样 -->
                <template v-else>
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148" v-if="$store.getters.hasPermission('system:supplier:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleEditSupplier(scope.row)" size="mini"
                             :disabled="scope.row.clinicId === 0">编辑
                  </el-button>
                  <el-button
                      :disabled="scope.row.clinicId === 0"
                      :type="scope.row.status === 1 ? 'danger' : 'success'"
                      @click="handleStartOrDisabled(scope.row)"
                      size="mini"
                  >
                    {{ scope.row.status === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
            :title='addSupplierForm.id == null ? "新增供货单位" : (showSupplierDialogVisible ? "查看供货单位" : "修改供货单位")'
            :visible.sync="addSupplierDialogVisible"
            :close-on-click-modal="false"
            width="700px"
            @close="handleCloseSupplier"
            class="custom-form-dialog"
        >
          <el-form
              size="mini"
              :model="addSupplierForm"
              ref="addSupplierForm"
              :rules="addSupplierFormRules"
              label-width="120px"
              label-position="right"
              :disabled="showSupplierDialogVisible"
          >
            <!-- 第一行：联系人 + 联系人电话 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人:" prop="contact">
                  <el-input v-model="addSupplierForm.contact" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人电话:" prop="contactPhone">
                  <el-input v-model="addSupplierForm.contactPhone" clearable @blur="validatePhone" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行：供货商名称 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="供货商名称:" prop="supplierName">
                  <el-input v-model="addSupplierForm.supplierName" type="textarea" rows="1" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 供货商地址 -->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="供货商地址:" prop="address">
                  <el-input v-model="addSupplierForm.address" type="textarea" rows="1" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 期初金额 + 状态 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="期初金额:" prop="beginAmt">
                  <el-input-number :min="0" v-model="addSupplierForm.beginAmt" :disabled="addSupplierForm.id !== null" style="width: 100%;" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态:" prop="status">
                  <el-select v-model="addSupplierForm.status" style="width: 100%">
                    <el-option
                        v-for="item in stateOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 码上放心字段 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="码上放心企业ID:" prop="entId">
                  <el-input v-model="addSupplierForm.entId" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业唯一标识:" prop="refEntId">
                  <el-input v-model="addSupplierForm.refEntId" clearable />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 许可证号 -->
            <el-form-item label="许可证号:" prop="permitNumber">
              <el-input v-model="addSupplierForm.permitNumber" type="textarea" rows="1" />
            </el-form-item>



            <!-- 备注 -->
            <el-form-item label="备注:" prop="remark">
              <el-input type="textarea" v-model="addSupplierForm.remark" rows="1" />
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showSupplierDialogVisible" size="mini" type="primary" @click="handleAddSupplier">保存</el-button>
            <el-button :disabled="showSupplierDialogVisible" size="mini" @click="handleCloseSupplier">取消</el-button>
          </div>
        </el-dialog>

      </div>
    </div>

    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>

<script>
import {getArea, getContuntList, getDeptList} from "@/api/reservation/reservation";
import {getOnCredit} from "@/api/reservation/onCredit";
import dayjs from "dayjs";
import {withLoading} from "@/untils/loading";
import {getExpenseCategoryList} from "@/api/managementMenu/expenseCategory";
import {SupplierEntityList} from "@/api/PSI/shopReturn";
import {addSupplierEntity, editSupplierEntity, SupplierDetails} from "@/api/supplier";

export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // 树菜单Props
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // str
      windowWidth: '', //右侧表格动态宽度
      searchValue: '',
      CatalogueName: '供货单位',
      DropDownedName: '全部',
      state: null,
      iconComes: 'el-icon-byj',
      queryConditionForm: {
        name: '',
        timeFrameArr: [
          dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
        ],
        status: null,
      },

      //模态框控制
      loading: false,
      addSupplierDialogVisible: false,
      showSupplierDialogVisible: false,

      //分页参数
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,

      applyobjectOptions: [{id: 0, label: '全部'}, {id: 1, label: '门诊'}, {id: 2, label: '住院'}],
      stateOption: [{id: 1, label: '正常'}, {id: 2, label: '禁用'}],
      doctorOptions: [],

      //表单验证
      addSupplierFormRules: {
        // contact: [
        //   {required: true, message: ' ', trigger: 'change'}
        // ],
        // beginAmt: [
        //   { required: true, message: ' ', trigger: 'change' },
        //   {
        //     pattern: /^(?:0|[1-9]\d*)(?:\.\d+)?$/,
        //     message: '请输入非负数字（可包含小数）',
        //     trigger: 'blur'
        //   }
        // ],
        // contactPhone: [
        //   {required: true, message: ' ', trigger: 'change'},
        //   {
        //     pattern: /^(0\d{2,3}-\d{7,8}|1[3-9]\d{9})$/,
        //     message: '请输入正确的手机号或座机号（座机格式：区号-号码）',
        //     trigger: 'blur'
        //   }
        // ],
        supplierName: [
          {required: true, message: ' ', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur'}
        ],
      },
      addressKey: null,
      addressProps: {
        lazy: true,
        value: 'areaCode',
        label: 'areaName',
        emitPath: true,
        leaf: node => node.areaLevel >= 5,
        lazyLoad: async (node, resolve) => {
          try {
            const level = node.level + 1;

            // 限制最大层级为5
            if (level > 5) {
              return resolve([]);
            }

            // 请求参数
            const params = {
              areaCode: node.level > 0 ? node.data.areaCode : undefined,
              areaLevel: level,
              condtion: ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'][level - 1]
            };

            const res = await getArea(params);
            const responseData = res?.data || [];

            // 如果没有数据，关闭下拉框
            if (responseData.length === 0 && level > 1) {
              this.handleCloseCascader();
            }

            // 格式化数据（关键修改：添加 isLeaf 和 level 属性）
            const formattedData = responseData.map(item => ({
              ...item,
              value: item.areaCode, // 严格模式需要 value 字段
              label: item.areaName,
              level: level, // 标记当前层级
              isLeaf: level >= 5 // 第五级强制设为叶子节点
            }));

            resolve(formattedData);

          } catch (error) {
            console.error('加载地区数据失败:', error);
            resolve([]);
          }
        }
      },
      provinces: [],
      conerPleasett: '',
      //表单容器
      addSupplierForm: {
        address: "",
        clinicId: null,
        contact: "",
        contactPhone: "",
        id: null,
        payAmt: null,
        beginAmt: null,
        permitNumber: "",
        receAmt: null,
        remark: "",
        status: 1,
        supplierName: "",
        conerAddCodeArr: [],
        entId: "",      // 新增：码上放心企业ID
        refEntId: "",   // 新增：企业唯一标识
      },

      //表格容器
      tableData: [],

      //动态按钮
      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
        {add: "add", title: "新增", type: "warning",auth:'system:supplier:add'},
      ],
      //侧边树
      elTree: [
        {label: '全部', path: '', title: '', icon: 'el-icon-news', children: []},
      ],

      //动态列容器
      tableRows: [
        {name: "系统序号", prop: "id", type: ""},
        {name: "供货商名称", prop: "supplierName", type: ""},
        {name: "供货商地址", prop: "address", type: ""},
        {name: "联系人", prop: "contact"},
        {name: "联系人电话", prop: "contactPhone"},
        {name: "许可证号", prop: "permitNumber", type: ""},
        {name: "应付金额", prop: "payAmt", type: ""},
        {name: "应收金额", prop: "receAmt", type: ""},
        {name: "状态", prop: "status", type: ""},
        {name: "备注", prop: "remark", type: ""},
      ],

      areaOption: [{id: 1, label: '省内'}, {id: 2, label: '省外'}, {id: 3, label: '进口'}],

      expenseCategoryOptions: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    validatePhone() {
      // 正则表达式匹配手机号或座机号
      const phoneReg = /^(0\d{2,3}-\d{7,8}|1[3-9]\d{9})$/;

      if (!phoneReg.test(this.addSupplierForm.contactPhone)) {
        this.$message.error('请输入正确的手机号或座机号（座机格式：区号-号码）');
        return false;
      }
      return true;
    },
    async loadSelectedPath(type = 'coner') {
      try {
        // 1. 确保省级数据已加载
        if (this.provinces.length === 0) {
          await this.loadProvincial();
        }

        // 2. 根据类型获取对应字段
        const codeKey = `${type}AddCodeArr`;
        const codes = this.addSupplierForm[codeKey] || [];

        // 3. 定义各级请求条件
        const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code', 'area_t_code'];
        let currentNodes = this.provinces;
        const loadedCodes = [];

        // 4. 按层级逐级加载
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i];
          const level = i + 1; // 1:省, 2:市, 3:区, 4:镇, 5:社区

          // 尝试从当前层级查找节点
          let targetNode = currentNodes.find(node => node.areaCode === code);

          // 如果未找到，动态加载该级数据
          if (!targetNode) {
            const parentCode = i > 0 ? codes[i - 1] : undefined;
            const params = {
              areaCode: parentCode,
              areaLevel: level,
              condtion: levelConditions[i]
            };
            const res = await getArea(params);
            currentNodes = res.data || [];
            targetNode = currentNodes.find(node => node.areaCode === code);

            // 更新省级数据缓存
            if (level === 1) {
              this.provinces = currentNodes;
            }
          }

          if (!targetNode) {
            break;
          }

          loadedCodes.push(code);

          // 动态加载下一级数据（如果未到末级）
          if (level < 5 && (!targetNode.children || targetNode.children.length === 0)) {
            const nextLevelParams = {
              areaCode: code,
              areaLevel: level + 1,
              condtion: levelConditions[level]
            };
            const res = await getArea(nextLevelParams);
            targetNode.children = res.data || [];

            // 如果是第四级，设置其子节点为叶子节点
            if (level === 5) {
              targetNode.children.forEach(item => {
                item.isLeaf = true;  // 标记为叶子节点，不显示下拉箭头
              });
            }
          }

          currentNodes = targetNode.children || [];
        }

        this.$nextTick(() => {
          // 强制刷新级联选择器
          this.addSupplierForm[codeKey] = [];
          setTimeout(() => {
            this.addSupplierForm[codeKey] = [...loadedCodes];
          }, 200);
        });

      } catch (error) {
        console.error(`加载${type}地址路径失败:`, error);
        this.$message.error(`${type === 'coner' ? '联系' : '籍贯'}地址加载失败，请重试`);
      }
    },
    async initAddressData() {
      try {
        // 确保省级数据已加载
        if (this.provinces.length === 0) {
          await this.loadProvincial();
        }

        // 如果存在有效编码才加载路径
        if (this.addSupplierForm.conerAddCodeArr.length > 0) {
          await this.loadSelectedPath('coner');
        }
      } catch (error) {
        console.error('地址初始化失败:', error);
      }
    },



    handleRemoveChange(item) {
      if (item.length <= 0) return;
      this.expenseCategoryOptions.push(item[item.length - 1]);
    },
    handleRemoveTage(tag) {
      this.$set(this.expenseCategoryOptions, this.expenseCategoryOptions.filter(item => item.id === tag));
    },
    async getExpenseCategoryList(query) {
      const res = await getExpenseCategoryList({name: query});
      if (res.code === 200) {
        this.expenseCategoryOptions = res.data.map(item => {
          return {id: item.id, applyobject: item.applyobject, label: item.name}
        });
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员")
      }

      /*const merged = this.expenseCategoryOptions.concat(list);
      this.expenseCategoryOptions = merged.filter((item,index,self) => {
        return self.findIndex(obj => obj.id === item.id) === index;
      })
      console.log(this.expenseCategoryOptions,'this.expenseCategoryOptionsthis.expenseCategoryOptions')*/
    },
    async handleConditionQuery() {
      try {
        const res = await getOnCredit({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',  // name为空时传空字符串
          startTime: this.queryConditionForm.timeFrameArr?.[0] || '',  // 使用可选链更安全
          endTime: this.queryConditionForm.timeFrameArr?.[1] || '',    // 使用可选链更安全
          state: this.state ?? null  // 使用空值合并运算符
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {
            return {
              ...item,
              createTime: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
              endTime: item.endTime ? dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
              beginTime: item.beginTime ? dayjs(item.beginTime).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          })
          await this.getContuntList();
        } else {
          this.$message.error("系统异常:请联系管理员")
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员")
      } finally {

      }
    },

    //修改
    async handleEditSupplier(row) {
      const res = await SupplierDetails({id:row.id});
      if (res.code === 200) {
        this.addSupplierForm = JSON.parse(JSON.stringify(res.data))
        this.addSupplierDialogVisible = true;
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员")
      }
    },

    //新增修改
    async handleAddSupplier() {
      try {
        await this.$refs.addSupplierForm.validate();
      } catch (error) {
        this.$message.warning("请完善表单信息")
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        let res;
        if (!this.addSupplierForm.id) {
          res = await addSupplierEntity(this.addSupplierForm);
        } else {
          res = await editSupplierEntity(this.addSupplierForm);
        }
        if (res.code === 200) {
          this.handleCloseSupplier();
          await this.loadData();
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    //合约单位下拉框
    async getContuntList() {
      if (this.contractUnitOption.length > 0) return;
      const res = await getContuntList();
      this.contractUnitOption = res.data.map(item => {
        return {id: item.id, label: item.name}
      })
    },

    //关闭模态框清空数据
    handleCloseSupplier() {
      this.addSupplierForm = Object.assign({}, this.$options.data.call(this).addSupplierForm);
      this.$nextTick(() => {
        this.$refs.addSupplierForm.clearValidate();
      });
      this.addSupplierDialogVisible = false;
      this.showSupplierDialogVisible = false;
    },


    //科室下拉框
    async getDeptList() {
      const res = await getDeptList()
      this.deptOptions = res.data.map(item => {
        return {id: item.id, label: item.deptName}
      })
    },


    //启用禁用
    async handleStartOrDisabled(row) {
      try {
        // 确认弹框
        const confirmMessage = row.status === 1 ? `确定要禁用${row.supplierName}吗？` : `确定要启用${row.supplierName}吗？`;
        const confirmResult = await this.$confirm(confirmMessage, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => {
          return false;
        });

        // 如果用户点击取消，直接返回
        if (!confirmResult) return;

        // 执行状态修改
        this.addSupplierForm = {...row};
        this.addSupplierForm.status = row.status === 1 ? 2 : 1;
        const res = await editSupplierEntity(this.addSupplierForm);
        if (res.code === 200) {
          await this.loadData();
          this.$message.success(`修改${this.addSupplierForm.supplierName}状态成功`);
        } else {
          this.$message.error(`修改${this.addSupplierForm.supplierName}状态失败`);
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作过程中发生错误');
      }
    },

    //双击查看的当前行信息
    async handleDbShowData(row) {
      const res = await SupplierDetails({id:row.id});
      if (res.code === 200) {
        this.addSupplierForm = JSON.parse(JSON.stringify(res.data))
        this.addSupplierDialogVisible = true;
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员")
      }
      this.showSupplierDialogVisible = true;
    },

    //表格字段映射
    safeGetMappedValue(col, row) {
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id === rawValue);
      return matched?.label || rawValue;
    },

    //数据源
    async loadData() {
      try {
        const res = await SupplierEntityList({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          supplierName: this.queryConditionForm.name || '',  // name为空时传空字符串
          status: this.queryConditionForm.status ?? null,  // name为空时传空字符串
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content;
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员")
      } finally {

      }
    },

    //侧边树(全部)按钮
    handleNodeClick(data, e) {
      this.searchValue = '';
      this.loadData()
    },

    //动态计算列宽
    columnWidth(col, list) {
      let prop = col.prop, lab = col.lab;
      let width = 40; // 设定一个最小值
      let maxlenStr = ""; // 最长字符串
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      // 表格自带的内边距(20px) 自调
      return width + 12; // 这里加了 12px
      function len(str) {
        // 实际分配长度可根据需要自行调整
        let length = 8;
        for (const char of str + "") {
          // 英文小写字符 8px
          if ("a" <= char && char <= "z") length += 8;
          // 英文大写字符 8px
          else if ("A" <= char && char <= "Z") length += 8;
          // 中文字符 28px
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
          // 其他 8px
          else length += 12;
        }
        return length;
      }
    },

    // 步骤
    async handClick(i) {
      switch (i) {
        case 0:
          await this.loadData()
          break;
        case 1:
          this.addSupplierDialogVisible = true;
          break;
      }
    },

    //状态查询
    async handleCommand(command) {
      if (command === 'a') this.queryConditionForm.status = 1;
      else if (command === 'b') this.queryConditionForm.status = 2;
      else this.queryConditionForm.status = null;
      await this.loadData();
      this.DropDownedName = this.queryConditionForm.status === 1 ? '正常' : (this.queryConditionForm.status === 2 ? '禁用' : '全部');
    },

    // 实时宽度
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 328;
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 20; // 增加边距缓冲
      const contentList = tableData.map(item => item?.[prop] ?? '');

      // 计算所有内容宽度（包括表头）
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
  }
}
</script>

<style lang="less" scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 190px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.patient-dialog {
  .el-dialog {
    /* 改为动态高度控制 */
    max-height: 70vh !important;
    height: auto !important; /* 关键修改 */
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important; /* 上移对话框位置 */
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0; /* 防止头部被压缩 */

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      padding: 8px !important;
      overflow: hidden; /* 外层隐藏滚动 */
      display: flex;
      flex-direction: column;
      min-height: 0; /* 关键修复：允许flex子项收缩 */

      .aform, .bform {
        flex: 1;
        overflow-y: auto; /* 只在表单容器内滚动 */
        margin-bottom: 5px;
        min-height: 0; /* 关键修复 */

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0; /* 关键修复 */

          .el-tabs__content {
            flex: 1;
            overflow: visible; /* 禁用嵌套滚动 */
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0; /* 防止底部被压缩 */

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  /* 小屏幕适配 */
  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

/* 极紧凑表单样式 */
/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

// 穿透
/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  // align-items: center !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

  }

  // main
  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left
    .main-left {
      .custom-tree {
        max-height: 100%; /* 设置树形菜单的最大高度为父容器的100% */
        overflow-y: auto; /* 当内容超出设定高度时显示滚动条 */
      }

      /deep/ .el-tree-node__content {
        height: 40px;
        padding-left: 0 !important;
      }

      /deep/ .el-tree-node__label {
        font-size: 12px;
      }

      width: 10%;
      height: 100%;
    }

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // feet
  .feet {
    .addmessagesBox {
      .aform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }

      .bform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }
    }

    // alert
    .messagesBox {
      .tabs {

        /deep/ .el-form-item__content {
          display: flex;

          span {
            font-size: 12px;
          }
        }

        .oneLine {
          width: 524px;
          // background-color: indianred;
        }
      }

      /deep/ .el-dialog__title {
        font-size: 12px;
      }

      /deep/ .el-table {
        font-size: 12px;
      }

    }
  }

}
</style>